import { Injectable } from '@angular/core';
import * as Constants from '../models/Constants';
import { HttpClient } from '@angular/common/http';
import { Global } from '../global/globalApi';
import { RootScopeService } from './root-scope.service';

@Injectable({
  providedIn: 'root'
})
export class PrivacyPolicyService {

  constructor(public rootScope: RootScopeService, private http: HttpClient) { }

  /**
    * @author Amarjeet
    *getPrivacyPolicyStatus()-Method to get the privacy policy status
    */
  getPrivacyPolicyStatus() {
    let url = Global.domainUrl + Global.authenticationApis.getPrivacyPolicyStatus;
    return this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScope.activeCustTab.clientId
      }
    });
  }

  /**CCR3-14638
    * @author Amarjeet
    *updatePrivacyPolicyStatus()-Method to update the privacy policy status
    */
  updatePrivacyPolicyStatus(clientId) {
    let url = Global.domainUrl + Global.authenticationApis.updatePrivacyPolicyStatus;
    let payload = { clientId: clientId }
    return this.http.post(url, payload, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId)
    });
  }

}